// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Mb81","rootNoMargin":"styles_rootNoMargin__3ZsEp"};